export const DISTRIBUTOR_GET_REQUEST = 'DISTRIBUTOR_GET_REQUEST';
export const DISTRIBUTOR_GET_SUCCESS = 'DISTRIBUTOR_GET_SUCCESS';
export const DISTRIBUTOR_GET_FAIL = 'DISTRIBUTOR_GET_FAIL';


export const DISTRIBUTOR_MILESTONE_LIST_GET_REQUEST = 'DISTRIBUTOR_MILESTONE_LIST_GET_REQUEST';
export const DISTRIBUTOR_MILESTONE_LIST_GET_FAIL = 'DISTRIBUTOR_MILESTONE_LIST_GET_FAIL';
export const DISTRIBUTOR_MILESTONE_LIST_GET_SUCCESS = 'DISTRIBUTOR_MILESTONE_LIST_GET_SUCCESS';